import React, { useMemo, useState, useEffect } from 'react';

export default function VehicleSelector({ vehicles, onConfirm, loading, activeVehicleSession }) {
	const [selectedId, setSelectedId] = useState('');
	const switchLocked =
		Boolean(activeVehicleSession?.active_today) &&
		activeVehicleSession?.can_switch_active_vehicle === false;

	useEffect(() => {
		if (vehicles?.length > 0 && !selectedId) setSelectedId(String(vehicles[0].id));
	}, [vehicles, selectedId]);

	const selectedVehicle = useMemo(
		() => vehicles?.find((v) => String(v.id) === String(selectedId)) || null,
		[vehicles, selectedId]
	);

	return (
		<div className="card" style={{ maxWidth: 620, margin: '2rem auto' }}>
			<div className="card-header">
				<h3 style={{ margin: 0, fontFamily: 'var(--font-display)' }}>Select Today&apos;s Vehicle</h3>
			</div>
			<div className="card-body" style={{ display: 'grid', gap: '1rem' }}>
				<p style={{ margin: 0, color: 'var(--gray-600)' }}>
					Choose the vehicle you are driving today to continue.
				</p>

				{switchLocked && (
					<div style={{
						border: '1px solid var(--gray-200)',
						borderRadius: 'var(--radius-md)',
						padding: '0.7rem 0.85rem',
						fontSize: '0.86rem',
						color: 'var(--warning-text)',
						background: 'var(--warning-light)',
					}}>
						To switch vehicle, log out and sign in again.
					</div>
				)}

				<div className="form-group" style={{ marginBottom: 0 }}>
					<label className="form-label">Vehicle</label>
					<select
						className="form-control"
						value={selectedId}
						onChange={(e) => setSelectedId(e.target.value)}
						disabled={loading || !vehicles?.length || switchLocked}
					>
						{vehicles?.map((v) => (
							<option key={v.id} value={v.id}>
								{v.registration_number} - {v.make} {v.model}
							</option>
						))}
					</select>
				</div>

				<div style={{ fontSize: '0.86rem', color: 'var(--gray-500)' }}>
					{selectedVehicle ? `Route: ${selectedVehicle.route || 'Not set'}` : 'No vehicle selected'}
				</div>

				<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
					<button
						type="button"
						className="btn btn-primary"
						onClick={() => selectedVehicle && onConfirm(selectedVehicle)}
						disabled={!selectedVehicle || loading || switchLocked}
					>
						Continue
					</button>
				</div>
			</div>
		</div>
	);
}
